/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_ApplyInputs */

const id_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terapkan`)
};

const ms_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gunakan`)
};

const da_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anvend`)
};

const de_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwenden`)
};

const en_us2_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const es_es2_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const es_mx2_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const fil_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilapat`)
};

const fr_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer`)
};

const it_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica`)
};

const hu_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alkalmazás`)
};

const nl_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toepassen`)
};

const no_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruk`)
};

const pl_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastosuj`)
};

const pt_br2_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const pt_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const ro_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplică`)
};

const fi_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytä`)
};

const sv_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkställ`)
};

const vi_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áp dụng`)
};

const tr_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygula`)
};

const cs_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít`)
};

const bg_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приложи`)
};

const ru_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить`)
};

const uk_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Застосувати`)
};

const ar_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق`)
};

const hi_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लागू करें`)
};

const th_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้`)
};

const ja_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適用`)
};

const zh_cn2_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用`)
};

const zh_hant1_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`套用`)
};

const ko_builds_comparison_apply = /** @type {(inputs: Builds_Comparison_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`적용`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Builds_Comparison_ApplyInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_apply = /** @type {((inputs?: Builds_Comparison_ApplyInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_ApplyInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_apply(inputs)
	if (locale === "ms") return ms_builds_comparison_apply(inputs)
	if (locale === "da") return da_builds_comparison_apply(inputs)
	if (locale === "de") return de_builds_comparison_apply(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_apply(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_apply(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_apply(inputs)
	if (locale === "fil") return fil_builds_comparison_apply(inputs)
	if (locale === "fr") return fr_builds_comparison_apply(inputs)
	if (locale === "it") return it_builds_comparison_apply(inputs)
	if (locale === "hu") return hu_builds_comparison_apply(inputs)
	if (locale === "nl") return nl_builds_comparison_apply(inputs)
	if (locale === "no") return no_builds_comparison_apply(inputs)
	if (locale === "pl") return pl_builds_comparison_apply(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_apply(inputs)
	if (locale === "pt") return pt_builds_comparison_apply(inputs)
	if (locale === "ro") return ro_builds_comparison_apply(inputs)
	if (locale === "fi") return fi_builds_comparison_apply(inputs)
	if (locale === "sv") return sv_builds_comparison_apply(inputs)
	if (locale === "vi") return vi_builds_comparison_apply(inputs)
	if (locale === "tr") return tr_builds_comparison_apply(inputs)
	if (locale === "cs") return cs_builds_comparison_apply(inputs)
	if (locale === "bg") return bg_builds_comparison_apply(inputs)
	if (locale === "ru") return ru_builds_comparison_apply(inputs)
	if (locale === "uk") return uk_builds_comparison_apply(inputs)
	if (locale === "ar") return ar_builds_comparison_apply(inputs)
	if (locale === "hi") return hi_builds_comparison_apply(inputs)
	if (locale === "th") return th_builds_comparison_apply(inputs)
	if (locale === "ja") return ja_builds_comparison_apply(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_apply(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_apply(inputs)
	return ko_builds_comparison_apply(inputs)
});
export { builds_comparison_apply as "builds.comparison.apply" }